module.exports = __webpack_public_path__ + "static/img/8.21da305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8.png
// module id = KNp8
// module chunks = 10